import { css } from 'lit';
export default css `
    /*
        Inherited variables from parent component (Input)
        --input-background-color
        --input-border-color
        --input-box-shadow
        --input-cursor
        --input-focus-border-color
        --input-padding
        --input-validation-color
        --input-text-transform
    */
    :host {
        --icon-color: var(--color-primary);
        --input-padding: 0 var(--spacing-m);
        --input-max-width: 480px;

        --input-label-grid-area: none;
        --input-field-grid-area: none;
        --input-description-grid-area: none;
        --input-validation-grid-area: none;

        display: block;
        width: 100%;
    }

    :host([validation='error']) {
        --input-border-color: var(--color-error);
        --input-validation-color: var(--color-error);
        --input-focus-border-color: var(--color-error);

        --icon-color: var(--color-error);
    }

    :host([validation='success']) {
        --input-validation-color: var(--color-success);

        --icon-color: var(--color-success);
    }

    :host([max]:not([max='']):not([max='null']):not([max='0'])) .input {
        padding-right: 2.25rem;
    }

    :host([validation='success']) ::slotted(*[slot='validation-message']),
    :host([validation='error']) ::slotted(*[slot='validation-message']) {
        display: block;
    }

    :host([text-transform='uppercase']) {
        --input-text-transform: uppercase;
    }

    :host([text-transform='lowercase']) {
        --input-text-transform: lowercase;
    }

    ::slotted(*[slot='validation-message']) {
        display: none;
        color: var(--input-validation-color);

        line-height: var(--line-height-xxs);
        margin-top: var(--spacing-xxs);
        grid-area: var(--input-validation-grid-area);
    }

    ::slotted(*[slot='description']) {
        color: var(--color-ui-04);
        display: block;
        margin-top: var(--spacing-xxs);
        grid-area: var(--input-description-grid-area);
    }

    .container {
        align-items: center;
        display: flex;
        width: 100%;
        grid-area: var(--input-field-grid-area);
    }

    .input-container {
        align-items: center;
        display: flex;
        position: relative;
        width: 100%;
    }

    .input {
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        background-color: var(--input-background-color);
        border: solid 2px var(--input-border-color);
        border-radius: var(--radius-m);
        box-shadow: var(--input-box-shadow);
        box-sizing: border-box;
        color: var(--color-text);
        cursor: var(--input-cursor);
        display: block;
        font-family: var(--font-normal);
        font-size: 1rem;
        height: 3rem;
        line-height: normal;
        padding: var(--input-padding);
        transition: border-color var(--transition-speed), box-shadow var(--transition-speed);
        width: 100%;
        text-transform: var(--input-text-transform);
    }

    .input:focus {
        --input-border-color: var(--input-focus-border-color);
        --input-box-shadow: 0 0 4px 0 var(--input-focus-border-color);

        outline: 0;
    }

    .input:disabled {
        --input-background-color: var(--color-ui-06);
        --input-cursor: not-allowed;
    }

    /* Edge */
    .input::-webkit-input-placeholder {
        color: var(--color-ui-04);
        text-transform: none;
    }

    /* Internet Explorer 10-11 */
    .input:-ms-input-placeholder {
        color: var(--color-ui-04);
        text-transform: none;
    }

    .input::placeholder {
        color: var(--color-ui-03);
        text-transform: none;
    }

    .icon {
        margin-left: var(--spacing-xs);
    }

    .counter {
        color: var(--color-ui-03);
        position: absolute;
        right: calc(0.75rem + 2px);
    }

    label {
        display: table;
        font-weight: var(--weight-bold);
        margin-block-end: var(--spacing-s);
        grid-area: var(--input-label-grid-area);
    }

    @media screen and (min-width: 768px) {
        :host {
            max-width: var(--input-max-width);
        }
    }
`;
